
const digest = 'e801cd6cbc9c5965c4cba797a4fb210641009798c23d4fc036f7f2a648de3c20';
const css = `._anchorCopyLinkWrapper_bkak1_1 {
  position: absolute;
  margin-left: 0;
  transition: opacity 150ms 150ms, margin 200ms 150ms;
  opacity: 0;
  user-select: none;
}

._anchorCopyLinkContainer_bkak1_9:hover ._anchorCopyLinkWrapper_bkak1_1 {
  opacity: 0.5;
  margin-left: var(--spacer-2);
}

._anchorCopyLinkWrapper_bkak1_1:hover {
  opacity: 1 !important;
  transition: none;
}

._anchorCopyLink_bkak1_1 {
  font-size: 0.97rem;
  color: var(--theme-secondary-text);
  cursor: pointer;
  text-decoration: none;
  vertical-align: middle;
}

._anchorCopyLink_bkak1_1::after {
  /* I'm manually inserting the Font Awesome icon here because if we use */
  /* an 'i' tag (with ::before), it breaks certain cases for */
  /* text-highlighting in Chrome. */

  content: '\\f0c1'; /* fa-link */
  font-family: var(--fa-family-classic);
  font-weight: 400;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"anchorCopyLinkWrapper":"_anchorCopyLinkWrapper_bkak1_1","anchorCopyLinkContainer":"_anchorCopyLinkContainer_bkak1_9","anchorCopyLink":"_anchorCopyLink_bkak1_1"};
export { css, digest };
  